// Stable identity prevents two desks creating separate profiles for the same ID.
export async function guestIdentityKey(hotelId, idType, idNumber) {
  const number = String(idNumber || "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  if (!number) return "";
  const identity = JSON.stringify([String(hotelId || "").trim(), String(idType || "").trim().toLowerCase(), number]);
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(identity));
  return "G_" + Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, "0")).join("");
}

// Provisioning before check-in must never reset a concurrently committed visit.
export function provisionGuestProfile(current, payload, incrementVisitCount, timestamp) {
  const previousVisits = Math.max(0, Number(current?.visitCount) || 0);
  const next = { ...payload, visitCount: previousVisits + (incrementVisitCount ? 1 : 0) };
  if (!current) next.createdAt = timestamp;
  if (incrementVisitCount) {
    next.lastVisitAt = timestamp;
    next.lastVisitedAt = timestamp;
    if (!current?.firstVisitAt) next.firstVisitAt = timestamp;
  }
  if (current) {
    // Tags are edited by CRM, rather than by an old check-in form.
    for (const field of ["isVip", "isBlacklisted", "blacklistReason"]) {
      if (Object.prototype.hasOwnProperty.call(current, field)) next[field] = current[field];
    }
  }
  return next;
}
